import '@/assets/styles/global/index.scss';
import { installSharedRuntimeBridges } from '@/main';

let isInstalled = false;

/**
 * 安裝 account-login 入口所需 runtime
 */
const installAccountLoginRuntime = (): void => {
    if (isInstalled) return;

    installSharedRuntimeBridges();

    isInstalled = true;
};

installAccountLoginRuntime();
